import React from 'react';

import styles from './Document.module.scss';

export const Document: React.FC = ({ children }) => <div className={styles.Document}>{children}</div>;
